interface LoadingTableBodyWrapperProps {
  loading: boolean
  recordsCount: number
  columnsCount: number
  noDataText?: string
  children: React.ReactNode
}

function LoadingTableBodyWrapper(props: LoadingTableBodyWrapperProps) {
  const { loading, recordsCount, columnsCount, noDataText, children } = props

  return (
    <>
      {loading && recordsCount === 0 && (
        <tr>
          <td colSpan={columnsCount}>&nbsp;</td>
        </tr>
      )}
      {!loading && recordsCount === 0 && (
        <tr>
          <td colSpan={columnsCount}>{noDataText}</td>
        </tr>
      )}
      {children}
    </>
  )
}

LoadingTableBodyWrapper.defaultProps = {
  noDataText: "No Data Found",
}

export default LoadingTableBodyWrapper
